import type {FC} from 'react'
import templatesData from '../../data/hr/hrTemplatesData'
import CombinedWorkflow from '../universal-components/combined-workflow/CombinedWorkflow'
import {useTranslation} from 'react-i18next'

interface HRPageProps {}

const HRPage: FC<HRPageProps> = () => {
  const {t} = useTranslation()

  const title = t('common.human_resource')
  const buttonColor = 'var(--hr-workflow-btn-color)'

  return <CombinedWorkflow title={title} buttonColor={buttonColor} itemsData={templatesData} />
}

export default HRPage
